import { Box, Button, Chip, Fab, Grid, Stack, Typography } from "@mui/material";
import Templete from "../../template/Template";
import { MouseEvent, useEffect, useMemo, useState } from "react";
import { api } from "../../services/api";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { Link, useNavigate } from "react-router-dom";
import CardSimple from "../../components/Cards/CardSimple";
import ButtonCard from "../../components/ButtonCard/ButonCard";
import { endMes, formatDate, startMes } from "../../utilities/date";
import { AlertConfirm, AlertInfo } from "../../components/Alerts/Alert";
import { ProcessoType } from "../../types/ProcessoType";
import IconMenu from "../../components/Menu/IconMenu";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BalanceIcon from '@mui/icons-material/Balance';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import PolicyIcon from '@mui/icons-material/Policy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ElderlyIcon from '@mui/icons-material/Elderly';
import GavelIcon from '@mui/icons-material/Gavel';
import EditIcon from '@mui/icons-material/Edit';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import SearchIcon from '@mui/icons-material/Search';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HistoricoProcesso from "../../modals/processos/HistoricoProcesso";
import ObservacoesProcesso from "../../modals/processos/ObservacoesProcesso";
import ModalEnviarAssinatura, { SignerInit } from "../../components/ZapSign/ModalEnviarAssinatura";
import SearchProcessos from "./SearchProcessos";
import moment from "moment";
import { isPermite } from "../../utilities/isPermite";
import TableData from "../../components/Tables/TableData";
import { GridColDef } from "@mui/x-data-grid";
import Recibo from "../../modals/Recibo/Recibo";

type ServicoOption = { value: string | number; label?: string };
//TRABALHISTA; PENAL; e BANCÁRIO
function getIconeServico(value: string) {
    const v = value.toUpperCase();
    if (v === "CÍVEL" || v === "CIVEL") return <BalanceIcon sx={{ fontSize: 55 }} />;
    if (v === "ASSISTENCIAL") return <VolunteerActivismIcon sx={{ fontSize: 55 }} />;
    if (v === "PREVIDENCIÁRIO" || v === "PREVIDENCIARIO") return <ElderlyIcon sx={{ fontSize: 55 }} />;
    if (v === "TRABALHISTA") return <WorkHistoryIcon sx={{ fontSize: 55 }} />;
    if (v === "PENAL") return <PolicyIcon sx={{ fontSize: 55 }} />;
    if (v === "BANCÁRIO") return <AccountBalanceIcon sx={{ fontSize: 55 }} />;
    return <GavelIcon sx={{ fontSize: 55 }} />;
}

export default function Processos() {
    const navigate = useNavigate();
    const [activeProcess, setActiveProcess] = useState<null | ProcessoType>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [anchorElD, setAnchorElD] = useState<null | HTMLElement | MouseEvent<Element | EventTarget> >(null);
    const [anchorElRPV, setAnchorElRPV] = useState<null | HTMLElement | MouseEvent<Element | EventTarget> >(null);
    const [anchorElCH, setAnchorElCH] = useState<null | HTMLElement | MouseEvent<Element | EventTarget> >(null);
    const [anchorElKit, setAnchorElKit] = useState<null | HTMLElement | MouseEvent<Element | EventTarget> >(null);
    const [openLoad, setOpenLoad] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [openHistroy, setOpenHistory] = useState(false);
    const [openModalRecibo, setOpenModalRecibo] = useState(false);
    const [openModalObs, setOpenModalObs] = useState(false);
    const [arrHistory, setArrHistory] = useState([]);
    const [allRows, setAllRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [labelFilter, setLabelFilter] = useState("");
    const [arrServicos, setArrServicos] = useState<ServicoOption[]>([]);
    const [servicoSelecionado, setServicoSelecionado] = useState<string | null>(null);

    // ZapSign — habilitação + modal de envio para assinatura
    const [zapsignConfig, setZapsignConfig] = useState({ configurado: false, zapsign_envio_email: 0, zapsign_envio_whatsapp: 0 });
    const [openAssinatura, setOpenAssinatura] = useState(false);
    const [assinaturaDoc, setAssinaturaDoc] = useState<{ documentFile: string; nomeDocumento: string; signers: SignerInit[] }>({ documentFile: '', nomeDocumento: '', signers: [] });
    const columns: GridColDef[] = [
        {
            field: 'corretor_responsavel',
            headerName: 'PARCEIRO',
            width: 160,
        },
        {
            field: 'protocolo_processo',
            headerName: 'NUMERO PROCESSO',
            width: 220,
        },
        {
            field: 'nome_cliente',
            headerName: 'NOME',
            width: 320,
        },
        {
            field: 'causa_processual',
            headerName: 'CAUSA',
            width: 200,
        },
        {
            field: 'status_processo',
            headerName: 'STATUS',
            width: 200,
        },
        {
            field: 'create_processo',
            headerName: 'DATA CADASTRO',
            width: 140,
            valueFormatter: (dt: any) => formatDate(dt, "brH")
        },
    ];

    function editProcess() {
        if (activeProcess) {
            if (isPermite("32")) {
                navigate(`/cadastroprocesso?id=${activeProcess.id_processo}`);
            }
        }
    }

    function openDocument() {
        if (activeProcess) {
            setOpenLoad(true);
            setAnchorEl(null);
            api.get(`/createpeticao/${activeProcess.id_processo}`, { responseType: 'blob' }).then(response => {
                console.log(response);
                if (response.status === 204) {
                    return AlertInfo({ icon: 'error', title: "Documento não localizado" }).then(() => setOpenLoad(false));
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${activeProcess.causa_processual} - ${activeProcess.nome_cliente}.docx`;
                link.click();
                window.URL.revokeObjectURL(url);
                setOpenLoad(false);
            });
        }
    }

    function baixarDocumentoProcesso(docFile: string, nameDoc: string) {
        if (!activeProcess) return;
        setOpenLoad(true);
        api.get(`/documentrequerid/${docFile}/${activeProcess.id_processo}`, { responseType: 'blob' }).then(response => {
            if (response.status === 204) {
                return AlertInfo({ icon: 'error', title: "Documento não localizado" }).then(() => setOpenLoad(false));
            }
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${nameDoc} - ${activeProcess.nome_cliente}.docx`;
            link.click();
            window.URL.revokeObjectURL(url);
            setOpenLoad(false);
        });
    }

    function abrirAssinaturaProcesso(docFile: string, nameDoc: string) {
        if (!activeProcess) return;
        const infoLogin = JSON.parse(sessionStorage.getItem("infoLogin") || "{}");
        const signers: SignerInit[] = [
            {
                name: activeProcess.nome_cliente || '',
                cpf: activeProcess.cpf_cliente || '',
                phone: activeProcess.whatsapp_cliente || activeProcess.telefone_cliente || '',
                role: 'cliente',
                label: 'Cliente',
            },
            {
                name: infoLogin.nome_usuario || '',
                email: infoLogin.email_usuario || '',
                phone: infoLogin.telefone_usuario || '',
                cpf: infoLogin.cpf_usuario || '',
                role: 'advogado',
                label: 'Advogado',
            },
        ];
        setAssinaturaDoc({ documentFile: docFile, nomeDocumento: `${nameDoc} - ${activeProcess.nome_cliente}`, signers });
        setOpenAssinatura(true);
    }

    function openDocumentRequired(fileDoc: string, nameDoc: string, isComplement = false, permitirAssinatura = false, isAddGenero = false) {
        if (activeProcess) {
            setAnchorEl(null);
            setAnchorElD(null);
            setAnchorElRPV(null);
            setAnchorElCH(null);
            setAnchorElKit(null);
            let docFile = fileDoc;
            if(isAddGenero) docFile += `_${activeProcess.genero}`;
            if(isComplement){
                if(activeProcess.is_analfabeto) docFile+= '_analfabeto';
                else if(activeProcess.is_incapaz) docFile+= '_incapaz';
            }
            // Se a ZapSign estiver habilitada e o documento permitir assinatura, pergunta Baixar x Enviar
            if (permitirAssinatura && zapsignConfig.configurado) {
                AlertConfirm({
                    icon: 'info',
                    title: 'Assinatura eletrônica (ZapSign)',
                    text: 'Deseja enviar este documento para assinatura? Sim = enviar para assinatura • Não = baixar o documento.',
                }).then(r => {
                    if (r.isConfirmed) abrirAssinaturaProcesso(docFile, nameDoc);
                    else if (String(r.dismiss) === 'cancel') baixarDocumentoProcesso(docFile, nameDoc);
                });
                return;
            }
            baixarDocumentoProcesso(docFile, nameDoc);
        }
    }
    
    function openDocumentRecurso() {
        if (activeProcess) {
            const recurso = activeProcess.tipo_recurso;
            if(recurso.length === 0) return AlertInfo({icon:'info', title: 'Tipo Recurso não Selecionado'})
            const docFile = `${activeProcess.name_document}_${recurso}`;
            console.log(docFile);
            openDocumentRequired(encodeURI(`${docFile}`), `${activeProcess.causa_processual} ${recurso}`);
        }
    }

    async function openHistoryStatus() {
        if (activeProcess) {
            setOpenLoad(true);
            setAnchorEl(null);
            setAnchorElD(null);
            setAnchorElRPV(null);
            setAnchorElCH(null);
            setAnchorElKit(null);
            try {
                const response = await api.get(`/eventosproceso/${activeProcess.id_processo}`);
                if (response.status === 200 && response.data) {
                    if (response.data.error) {
                        AlertInfo({ icon: 'error', title: response.data.message });
                    } else {
                        setArrHistory(response.data);
                        setOpenHistory(true);
                    }
                }
            } catch (error) {
                console.log(error);
                AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            }
            setOpenLoad(false);
        }
    }

    function deleteProcess() {
        setAnchorEl(null);
        setAnchorElD(null);
        if(isPermite("33")){
            const text = 'Após deleta-lo ele não aparecerá nos registro de busca';
            AlertConfirm({ icon: 'info', title: 'Deletar Processo?', text }).then(async res => {
                if (res.isConfirmed) {
                    setOpenLoad(true);
                    try {
                        const data = {
                            id_processo: activeProcess?.id_processo,
                            processo_ativo: 0,
                            delete_processo: moment().format("YYYY-MM-DD HH:mm:ss"),
                        };
                        const response = await api.post(`/updateprocesso`, data);
                        if (response && response.status === 200 && response.data) {
                            if (response.data.success) {
                                AlertInfo({ icon: 'success', title: 'PROCESSO DELETADO' }).then(() => {
                                    loadData();
                                });
                            } else if (response.data.error) {
                                AlertInfo({ icon: 'error', title: response.data.message })
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                    }
                    setOpenLoad(false);
                }
            });
        }else{
            AlertInfo({ icon: 'info', title: 'Usuario sem permissão' });            
        }
    }

    function openObsProcess() {
        if(activeProcess){
            setOpenModalObs(true);
        }
    }

    // --- Menu de contexto por serviço advocatício (conforme documentos de atualização) ---
    // Prefixo do serviço para os documentos específicos (ex.: "PENAL" -> "penal").
    // Documentos compartilhados entre serviços mantêm nome genérico (atendimento, termos, RPV, entidade OAB).
    const servicoUpper = (servicoSelecionado || "").normalize("NFD").split("").filter((c) => { const n = c.charCodeAt(0); return n < 0x300 || n > 0x36f; }).join("").toUpperCase();
    const p = servicoUpper.replace(/[^A-Z0-9]+/g, "_").toLowerCase().replace(/^_+|_+$/g, "");
    const isAssistencial = servicoUpper === "ASSISTENCIAL";
    const isPrevidenciario = servicoUpper.startsWith("PREVIDENCI");
    const isCompleto = isAssistencial || isPrevidenciario; // serviços com Kit Assinaturas / Termos / RPV-BB

    type MenuItem = { icon: JSX.Element; title: string; handle: (event: MouseEvent<HTMLElement>) => void };

    const itemKit: MenuItem[] = isPrevidenciario
        ? [{ icon: <SensorOccupiedIcon fontSize="small" color="primary" />, title: "Kit Assinaturas", handle: (event: MouseEvent<HTMLElement>) => setAnchorElKit(event.currentTarget) }]
        : isAssistencial
            ? [{ icon: <SensorOccupiedIcon fontSize="small" color="primary" />, title: "Kit Assinaturas Assistencial", handle: () => openDocumentRequired('assistencial_kit_assinaturas', "Kit Assinaturas Assistencial", true, true, true) }]
            : [];

    const itemsCompleto: MenuItem[] = isCompleto
        ? [
            { icon: <SensorOccupiedIcon fontSize="small" color="primary" />, title: "Termo de Responsabilidade ADV", handle: () => openDocumentRequired('termo_responsabilidade_advogado', "Termo de Responsabilidade ADV", true) },
            { icon: <SensorOccupiedIcon fontSize="small" color="primary" />, title: "Termo do Responsável Legal", handle: () => openDocumentRequired('termo_responsavel_legal', "Termo do Responsável Legal", true) },
            { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Documentos RPV - BB", handle: (event: MouseEvent<HTMLElement>) => setAnchorElRPV(event.currentTarget) },
        ]
        : [];

    const arrMenu: MenuItem[] = [
        { icon: <EditIcon fontSize="small" color="primary" />, title: "Editar Processo", handle: editProcess },
        { icon: <DescriptionIcon fontSize="small" color="primary" />, title: "Gerar Petição", handle: openDocument },
        { icon: <RadioButtonCheckedIcon fontSize="small" color="primary" />, title: "Gerar Recurso/Resposta", handle: () => openDocumentRecurso() },
        { icon: <OutlinedFlagIcon fontSize="small" color="primary" />, title: "Atendimento Inicial", handle: () => openDocumentRequired('atendimento_inicial', 'Atendimento Inicial', true) },
        ...itemKit,
        { icon: <ChevronRightIcon fontSize="small" color="primary" />, title: "Procuração", handle: () => openDocumentRequired(`${p}_procuracao`, "Procuração", true, true, true) },
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declarações", handle: (event: MouseEvent<HTMLElement>) => setAnchorElD(event.currentTarget) },
        { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Contrato de Honorários", handle: (event: MouseEvent<HTMLElement>) => setAnchorElCH(event.currentTarget) },
        ...itemsCompleto,
        { icon: <PriceCheckIcon fontSize="small" color="primary" />, title: "Gerar Recibo", handle: () => setOpenModalRecibo(true) },
        { icon: <AccessTimeIcon fontSize="small" color="primary" />, title: "Historico de Status", handle: openHistoryStatus },
        { icon: <EditNoteIcon fontSize="small" color="primary" />, title: "Observações Processuais", handle: openObsProcess },
        { icon: <DeleteForeverIcon fontSize="small" color="primary" />, title: "Deletar Processo", handle: deleteProcess },
    ];

    const arrSubMenuDeclacao: MenuItem[] = [
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declaração de Hipossuficiência", handle: () => openDocumentRequired(`${p}_declaracao_hipossuficiencia`, "Declaração de Hipossuficiência", true, true, true) },
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declaração de Autenticidade", handle: () => openDocumentRequired(`${p}_declaracao_autenticidade`, "Declaração de Autenticidade", true, true, true) },
        ...(isCompleto
            ? [{ icon: <CheckIcon fontSize="small" color="primary" />, title: "Declaração de Entidade OAB", handle: () => openDocumentRequired('declaracao_entidade_oab', "Declaração de Entidade OAB", true, true, true) }]
            : []),
    ];

    const arrSubMenuRPV: MenuItem[] = [
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Declaração de Isenção IR", handle: () => openDocumentRequired('declaracao_isencao_rpv', "Declaração de Isenção IR", true, true, true) },
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Formulário Banco do Brasil", handle: () => openDocumentRequired('formulario_banco_brasil', "Formulário Banco do Brasil", true) },
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Procuração para RPV", handle: () => openDocumentRequired('procuracao_rpv', "Procuração para RPV", true, true, true) },
    ];

    const arrSubMenuContratoHonorarios: MenuItem[] = isPrevidenciario
        ? [
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Maternidade - Escritório", handle: () => openDocumentRequired(`${p}_contrato_honorarios_maternidade_escritorio`, "Contrato de Honorários PRV Maternidade - Escritório", true, true, true) },
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Maternidade - Advogado", handle: () => openDocumentRequired(`${p}_contrato_honorarios_maternidade_advogado`, "Contrato de Honorários PRV Maternidade - Advogado", true, true, true) },
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "30% - Escritório", handle: () => openDocumentRequired(`${p}_contrato_honorarios_30_escritorio`, "Contrato de Honorários PRV 30% - Escritório", true, true, true) },
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "30% - Advogado", handle: () => openDocumentRequired(`${p}_contrato_honorarios_30_advogado`, "Contrato de Honorários PRV 30% - Advogado", true, true, true) },
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Permanente - Escritório", handle: () => openDocumentRequired(`${p}_contrato_honorarios_permanente_escritorio`, "Contrato de Honorários PRV Permanente - Escritório", true, true, true) },
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Permanente - Advogado", handle: () => openDocumentRequired(`${p}_contrato_honorarios_permanente_advogado`, "Contrato de Honorários PRV Permanente - Advogado", true, true, true) },
        ]
        : [
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Em nome do escritório", handle: () => openDocumentRequired(`${p}_contrato_honorarios_escritorio`, "Contrato de Honorários - Escritório", true, true, true) },
            { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Em nome do advogado", handle: () => openDocumentRequired(`${p}_contrato_honorarios_advogado`, "Contrato de Honorários - Advogado", true, true, true) },
        ];

    const arrSubMenuKit: MenuItem[] = [
        { icon: <RadioButtonCheckedIcon fontSize="small" color="primary" />, title: "Previdenciário Maternidade", handle: () => openDocumentRequired(`${p}_kit_assinaturas_maternidade`, "Kit Assinaturas Maternidade", true, true, true) },
        { icon: <RadioButtonCheckedIcon fontSize="small" color="primary" />, title: "Previdenciário 30%", handle: () => openDocumentRequired(`${p}_kit_assinaturas_30`, "Kit Assinaturas 30%", true, true, true) },
        { icon: <RadioButtonCheckedIcon fontSize="small" color="primary" />, title: "Previdenciário Permanente", handle: () => openDocumentRequired(`${p}_kit_assinaturas_permanente`, "Kit Assinaturas Permanente", true, true, true) },
    ];


    function handleClick(process: ProcessoType, event: any) {
        setActiveProcess(process);
        setAnchorEl(event.currentTarget);
    }

    async function handleProcess(search: string) {
        setOpenLoad(true);
        let res = [];
        try {
            const response = await api.post(`/processos_clientes`, {nome_cliente: search});
            console.log(response);
            if (response && response.status === 200 && response.data) {
                if (response.data.error) {
                    AlertInfo({ icon: 'error', title: response.data.message });
                }else{
                    const arr = response.data;
                    res = arr.map((item: ProcessoType, index: number) => ({id: index, ...item}));
                }
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na Conexão' });
        }
        setOpenLoad(false);
        return res;
    }

    async function loadData() {
        setOpenLoad(true);
        try {
            const response = await api.post(`/processos`);
            if (response && response.status === 200 && response.data) {
                if (response.data.error) {
                    AlertInfo({ icon: 'error', title: response.data.message });
                } else {
                    const arr = response.data;
                    const data = arr.map((item: ProcessoType, index: number) => ({id: index, ...item}));
                    setAllRows(data);
                }
                setLabelFilter(`${formatDate(startMes(), "br")} à ${formatDate(endMes(), 'br')}`);
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na Conexão' });
        }
        setOpenLoad(false);
    }

    const rowsServico = useMemo(() => {
        if (!servicoSelecionado) return [];
        return allRows.filter((i: ProcessoType) => String(i.servico_advogado) === servicoSelecionado);
    }, [allRows, servicoSelecionado]);

    const counts = useMemo(() => ({
        cancelados: rowsServico.filter((i: ProcessoType) => i.codigo_status_processo === 1).length,
        preparacao: rowsServico.filter((i: ProcessoType) => i.codigo_status_processo === 2).length,
        andamento: rowsServico.filter((i: ProcessoType) => i.codigo_status_processo === 3).length,
        concluidos: rowsServico.filter((i: ProcessoType) => i.codigo_status_processo === 4).length,
    }), [rowsServico]);

    function filterProcess(cod: number) {
        const filter = rowsServico.filter((i: ProcessoType) => i.codigo_status_processo === cod);
        setRows(filter);
    }

    useEffect(() => {
        setRows(rowsServico);
    }, [rowsServico]);

    async function loadServicos() {
        try {
            const response = await api.get(`/optionsprocesso`);
            if (response?.data && !response.data.error && Array.isArray(response.data.servicos)) {
                setArrServicos(response.data.servicos);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        loadData();
        loadServicos();
        api.get('/configzapsign')
            .then(res => { if (res.data && !res.data.error) setZapsignConfig(res.data); })
            .catch(() => { });
    }, []);

    return (
        <Templete menuActive="processos">
            <SimpleBackdrop open={openLoad} />

            {servicoSelecionado === null ? (
                <>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h5" fontWeight="bold">Processos</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Selecione um serviço advocatício para listar os processos
                        </Typography>
                    </Box>
                    <Grid container spacing={1} justifyContent="center">
                        {arrServicos.map(s => (
                            <Grid item xs={12} sm={3} key={s.value}>
                                <ButtonCard
                                    icon={getIconeServico(String(s.value))}
                                    title={String(s.label || s.value)}
                                    handle={() => setServicoSelecionado(String(s.value))}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </>
            ) : (
                <>
                    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => setServicoSelecionado(null)}
                        >
                            Voltar
                        </Button>
                        <Typography variant="h6" fontWeight="bold">{servicoSelecionado}</Typography>
                    </Stack>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            {isPermite("31") && (
                                <Link to={`/cadastroprocesso?servico=${encodeURIComponent(servicoSelecionado || "")}`}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                    >
                                        NOVO PROCESSO
                                    </Button>
                                </Link>
                            )}
                        </Grid>
                        <Grid item xs={false} sm={6}></Grid>
                        <Grid item xs={12} sm={4} justifyContent="flex-end" container alignItems="center">
                            <Chip label={labelFilter} variant="outlined" onDelete={loadData} />
                            <Fab size="medium" color="primary" aria-label="search" onClick={() => setOpenSearch(true)} >
                                <SearchIcon />
                            </Fab>
                        </Grid>
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12} sm={3}>
                            <CardSimple
                                title="CANCELADOS"
                                txt={counts.cancelados}
                                color="bgError"
                                handle={() => filterProcess(1)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <CardSimple
                                title="EM PREPARAÇÃO"
                                txt={counts.preparacao}
                                color="bgPrimary"
                                handle={() => filterProcess(2)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <CardSimple
                                title="EM ANDAMENTO"
                                txt={counts.andamento}
                                color="bgBlue"
                                handle={() => filterProcess(3)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <CardSimple
                                title="CONCLUIDOS"
                                txt={counts.concluidos}
                                color="bgSuccess"
                                handle={() => filterProcess(4)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TableData
                                columns={columns}
                                rows={rows}
                                height={420}
                                handleClick={handleClick}
                                filter="nome_cliente"
                                title="PROCESSOS"
                                filterOut={handleProcess}
                            />
                            <IconMenu
                                anchorEl={anchorEl}
                                setAnchorEl={setAnchorEl}
                                arrMenu={arrMenu}
                            />
                            <IconMenu
                                anchorEl={anchorElD}
                                setAnchorEl={setAnchorElD}
                                arrMenu={arrSubMenuDeclacao}
                                subMenu
                            />
                            <IconMenu
                                anchorEl={anchorElRPV}
                                setAnchorEl={setAnchorElRPV}
                                arrMenu={arrSubMenuRPV}
                                subMenu
                            />
                            <IconMenu
                                anchorEl={anchorElCH}
                                setAnchorEl={setAnchorElCH}
                                arrMenu={arrSubMenuContratoHonorarios}
                                subMenu
                            />
                            <IconMenu
                                anchorEl={anchorElKit}
                                setAnchorEl={setAnchorElKit}
                                arrMenu={arrSubMenuKit}
                                subMenu
                            />
                        </Grid>
                    </Grid>
                </>
            )}

            <HistoricoProcesso
                open={openHistroy}
                setOpen={setOpenHistory}
                historico={arrHistory}
            />
            <SearchProcessos
                open={openSearch}
                setOpen={setOpenSearch}
                setAllRows={setAllRows}
                setLabelFilter={setLabelFilter}
                servicoInicial={servicoSelecionado ?? ""}
            />
            <Recibo
                open={openModalRecibo}
                setOpen={setOpenModalRecibo}
                activeProcess={activeProcess}
            />
            <ObservacoesProcesso
                open={openModalObs}
                setOpen={setOpenModalObs}
                activeProcess={activeProcess}
                onSaved={loadData}
            />
            <ModalEnviarAssinatura
                open={openAssinatura}
                setOpen={setOpenAssinatura}
                tipo="processo"
                documentFile={assinaturaDoc.documentFile}
                nomeDocumento={assinaturaDoc.nomeDocumento}
                dadosDocumento={{}}
                id_processo={activeProcess?.id_processo ?? null}
                id_cliente={activeProcess?.id_cliente_processo ?? null}
                signersIniciais={assinaturaDoc.signers}
                config={zapsignConfig}
            />
        </Templete>
    );
}